import { DefaultAttributeValue } from '@source-components-react/types';

export const DEFAULT_CONTENT_TEXT =
  'This is a text block. Click to edit and add your own content.';

export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: 'content-text-3-resolutions',
    defaultValues: {
      all: DEFAULT_CONTENT_TEXT,
    },
  },
  {
    name: 'enclosing-tag-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'links-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'inline-styles-3-resolutions',
    defaultValues: {},
  },
];
